import {
    SET_INTERVENTIONS,
    SET_FILTERED_AND_SORTED_INTERVENTIONS,
    SET_DISPLAY_INTERVENTIONS_WITHOUT_CERFA,
    SET_DISPLAY_ENDED_INTERVENTIONS,
    SET_SELECTED_TYPE,
    SET_SELECTED_STATE,
    SET_END_DATE,
    SET_START_DATE,
    SET_DISPLAY_AS_LIST,
    SET_CURRENT_INTERVENTION,
    SET_ATTACHMENTS
} from './extranetInterventionConstants';
import { setValue } from '../../lib/immutable_wrapper'
import { ALL_SELECT_OPTION } from '../../constants';
import { getFilterStates, getTypes } from './extranetInterventionActions';

const initialState = {
    allInterventions: [],
    filteredAndSortedInterventions: [],
    types: getTypes(),
    states: getFilterStates(),
    selectedState: ALL_SELECT_OPTION,
    selectedType: ALL_SELECT_OPTION,
    startDate: null,
    endDate: null,
    displayInterventionsWithoutCerfa: true,
    displayEndedInterventions: false,
    displayAsList: true,
};

const interventionInitialState = {
    currentIntervention: null,
    attachments: [],
};

export function extranetInterventions(state = initialState, action) {
    switch (action.type) {
        case SET_INTERVENTIONS:
            return setValue(state, ['allInterventions'], action.interventions);
        case SET_FILTERED_AND_SORTED_INTERVENTIONS:
            return setValue(state, ['filteredAndSortedInterventions'], action.filteredAndSortedInterventions);
        case SET_DISPLAY_INTERVENTIONS_WITHOUT_CERFA:
            return setValue(state, ['displayInterventionsWithoutCerfa'], action.displayInterventionsWithoutCerfa);
        case SET_DISPLAY_ENDED_INTERVENTIONS:
            return setValue(state, ['displayEndedInterventions'], action.displayEndedInterventions);
        case SET_DISPLAY_AS_LIST:
            return setValue(state, ['displayAsList'], action.displayAsList);
        case SET_SELECTED_TYPE:
            return setValue(state, ['selectedType'], action.selectedType);
        case SET_SELECTED_STATE:
            return setValue(state, ['selectedState'], action.selectedState);
        case SET_END_DATE:
            return setValue(state, ['endDate'], action.endDate);
        case SET_START_DATE:
            return setValue(state, ['startDate'], action.startDate);
        default:
            return state;
    }
}

export function extranetIntervention(state = interventionInitialState, action) {
    switch (action.type) {
        case SET_CURRENT_INTERVENTION:
            return setValue(state, ['currentIntervention'], action.intervention);
        case SET_ATTACHMENTS:
            return setValue(state, ['attachments'], action.attachments)
        default:
            return state;
    }
}